var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.6164,
    cy: 28.5076,
    r: 21.6164,
    fill: "#FBD904",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8136 7.81359C22.3345 7.29266 23.0411 7 23.7778 7H28.3319C28.6234 6.99983 28.9075 7.09135 29.1441 7.2616C29.3806 7.43185 29.5576 7.6722 29.65 7.94861L31.7306 14.1917C31.836 14.5088 31.8235 14.8533 31.6954 15.162C31.5674 15.4707 31.3323 15.7229 31.0333 15.8722L27.8986 17.4389C29.4349 20.8402 32.1587 23.5645 35.5597 25.1014L37.1292 21.9667C37.2785 21.6677 37.5307 21.4326 37.8394 21.3046C38.1481 21.1765 38.4926 21.164 38.8097 21.2694L45.05 23.35C45.3264 23.4421 45.5669 23.6188 45.7374 23.8551C45.9079 24.0914 45.9998 24.3753 46 24.6667V29.2222C46 29.9589 45.7073 30.6655 45.1864 31.1864C44.6655 31.7073 43.9589 32 43.2222 32H41.8333C30.3278 32 21 22.6722 21 11.1667V9.77778C21 9.04107 21.2927 8.33453 21.8136 7.81359Z",
    stroke: "#434343",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9993 7L37.666 15.3333M37.666 15.3333V8.38889M37.666 15.3333H44.6105",
    stroke: "#FBD904",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5ad68ffb9720dce921fe92b58afc15d2.svg";
export { ForwardRef as ReactComponent };